/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router/es6';
import getRoutes from './routes';
import { Provider } from 'react-redux';
import configureStore from './redux/configureStore';
import { syncHistoryWithStore } from 'react-router-redux';
import ApiClient from './helpers/ApiClient';

const client = new ApiClient();
const store = configureStore(window.__data, browserHistory, client);
const history = syncHistoryWithStore(browserHistory, store);

const targetElement = document.getElementById('content');

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} routes={getRoutes} />
  </Provider>,
  targetElement
);

if (module.hot) {
  module.hot.accept('./routes', () => {
    const nextRoutes = require('./routes').default;

    ReactDOM.render(
      <Provider store={store}>
        <Router history={browserHistory} routes={nextRoutes} />
      </Provider>,
      targetElement
    );
  });

  const reporter = window.__webpack_hot_middleware_reporter__;
  const success = reporter.success;
  const DEAD_CSS_TIMEOUT = 3000;

  reporter.success = () => {
    document.querySelectorAll('link[href][rel=stylesheet]').forEach((link) => {
      const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      const newLink = link.cloneNode();
      newLink.href = nextStyleHref;

      link.parentNode.appendChild(newLink);
      setTimeout(() => {
        link.parentNode.removeChild(link);
      }, DEAD_CSS_TIMEOUT);
    });
    success();
  };
}



// WEBPACK FOOTER //
// ./Scripts/client.js